import { cx } from 'class-variance-authority';
import type { ClassValue } from 'class-variance-authority/types';
import LOGIN_BACKGROUND_IMAGE from '~/../public/images/loginBackground.jpg';
import Image, { type ImageProps } from 'next/image';
import { curryProps } from '~/utils/react';

export const SaturatedImage: React.FC<
    Pick<ImageProps, 'src' | 'alt' | 'quality'> & {
        className?: string;
        /** @default VARIANTS */
        theme?: keyof typeof VARIANTS;
    }
> = props => {
    const variant = VARIANTS[props.theme ?? 'funkey'];

    return (
        <div
            className={cx(
                'left-O absolute top-0 h-full w-full overflow-hidden',
                variant.outerWrapper,
                props.className,
            )}
        >
            <div
                className={cx(
                    'img-wrapper position-relative flex h-full overflow-hidden object-cover',
                    variant.innerWrapper,
                )}
            >
                <Image
                    src={props.src}
                    alt={props.alt}
                    fill
                    quality={props.quality ?? 95}
                    placeholder="blur"
                    className="position-relative object-cover mix-blend-multiply grayscale"
                    sizes="100vw"
                />
            </div>
        </div>
    );
};

const VARIANTS = {
    funkey: {
        outerWrapper: 'bg-blue-900',
        innerWrapper: 'bg-secondary before:bg-blue-900!',
    },
    black: {
        outerWrapper: 'bg-black',
        innerWrapper: 'bg-gray-700 before:bg-black!',
    },
} as const satisfies Record<
    string,
    {
        outerWrapper: ClassValue;
        innerWrapper: ClassValue;
    }
>;

export const LoginBackgroundImage = curryProps(SaturatedImage, {
    src: LOGIN_BACKGROUND_IMAGE,
    alt: 'Login background image',
});
